import { useRecordContext } from 'components/record/useRecordContext';

const useIsOrienteering = () => {
  const {record: event} = useRecordContext();
  
  return event?.category === 'orienteering';
}

export default useIsOrienteering
